import { Link } from "@/components/LocalizedLink";
import { useLang } from "@/i18n/LanguageContext";
export default function NotFound() {
  const { tx } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-6 pb-28 pt-40">
      <p className="font-mono text-xs tracking-widest text-slate-500">404</p>
      <h1 className="mt-6 font-display text-4xl font-bold">
        {tx("Page not found.", "Sayfa bulunamadı.")}
      </h1>
      <p className="mt-6 max-w-xl text-slate-600">
        {tx(
          "This address does not point to an available page. Browse our portfolio or learn about Cernio from the homepage.",
          "Bu adreste bir sayfa bulunmuyor. Ana sayfadan portföyümüze ve Cernio hakkındaki bilgilere ulaşabilirsiniz.",
        )}
      </p>
      <Link
        to="/"
        className="focus-ring mt-8 inline-block bg-ink px-6 py-3 text-white"
      >
        {tx("Back to homepage", "Ana sayfaya dön")}
      </Link>
    </section>
  );
}
